import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Text } from '@chakra-ui/react'
import { colors } from '../../../utilities/colors'
import CarpoolVehiclesList from '../shared/CarpoolVehiclesList'
import LocationCard from '../Quotes/wizard/LocationCard'
import LocationInstructions from './LocationInstructions'
import SectionLabel from '../Quotes/wizard/SectionLabel'
import StatusBadge from '../shared/StatusBadge'
import VehicleTrackingModal from '../shared/VehicleTrackingModal'
import { vehicleStatusColor, isVehicleCanceled } from '../shared/vehicleStatus'

export default function OrderSummary({ origin, destination, vehicles }) {
  const { t } = useTranslation()
  const [trackingVehicle, setTrackingVehicle] = useState(null)

  const orderTrailing = (vehicle) => {
    return (
      <Box display="flex" flexDirection="column" alignItems="stretch" gap={1} minW="90px">
        {vehicle.status && (
          <StatusBadge label={vehicle.status} color={vehicleStatusColor(vehicle.status)} />
        )}
        {vehicle.tracking_url && !isVehicleCanceled(vehicle.status) && (
          <Text
            as="button"
            type="button"
            onClick={() => setTrackingVehicle(vehicle)}
            fontSize="xs"
            fontWeight="semibold"
            px={2}
            py={0.5}
            borderRadius="full"
            border="1px solid"
            borderColor={colors.green}
            color={colors.green}
            textAlign="center"
            _hover={{ bg: colors.green, color: colors.grey100, cursor: 'pointer' }}
          >
            {t('Track')}
          </Text>
        )}
      </Box>
    )
  }

  return (
    <Box display="flex" flexDirection="column" w="full" gap={4}>
      <Box display="flex" flexDirection="row" gap={2}>
        <Box display="flex" flexDirection="column" gap={2} flex={1} minW={0}>
          <SectionLabel text={t('From')} accent={colors.yellow} />
          <LocationCard loc={origin} accent={colors.yellow} />
          <LocationInstructions label={t('Pickup Instructions')} notes={origin?.external_notes} />
        </Box>

        <Box display="flex" flexDirection="column" gap={2} flex={1} minW={0}>
          <SectionLabel text={t('To')} accent="#4A90D9" />
          <LocationCard loc={destination} accent="#4A90D9" />
          <LocationInstructions label={t('Delivery Instructions')} notes={destination?.external_notes} />
        </Box>
      </Box>

      <CarpoolVehiclesList vehicles={vehicles} trailing={orderTrailing} />

      <VehicleTrackingModal
        isOpen={Boolean(trackingVehicle)}
        onClose={() => setTrackingVehicle(null)}
        trackingUrl={trackingVehicle?.tracking_url}
        vehicle={trackingVehicle}
      />
    </Box>
  )
}
